import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { FileText, Film, Music, Archive, FileQuestion, Image as ImageIcon, type LucideIcon } from 'lucide-react';
import type { AssetKind } from '@shared/types';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatFileSize(bytes: number): string {
  if (bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${(bytes / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

/** Short absolute date, e.g. "3 Aug 2026, 14:22". */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** Icon + tint per asset kind, for grid tiles without a thumbnail. */
export const KIND_ICON: Record<AssetKind, LucideIcon> = {
  folder: FileQuestion,
  image: ImageIcon,
  document: FileText,
  video: Film,
  audio: Music,
  archive: Archive,
  text: FileText,
  unknown: FileQuestion,
};

export const KIND_TINT: Record<AssetKind, string> = {
  folder: 'text-slate-400',
  image: 'text-emerald-500',
  document: 'text-red-500',
  video: 'text-violet-500',
  audio: 'text-amber-500',
  archive: 'text-orange-500',
  text: 'text-sky-500',
  unknown: 'text-slate-400',
};
